





















import { Vue, Component } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { token } from "@/plugins/checkToken";
import { setAuthTokens } from "axios-jwt";

@Component({
  components: { CustomButton }
})
export default class ShareAccess extends Vue {
  backToken!: { accessToken: string; refreshToken: string } | null;
  expired!: Date;
  timeLeft = {
    days: 0,
    hours: 0,
    mins: 0,
    seconds: 0
  };
  data() {
    return {
      backToken: undefined,
      expired: undefined
    };
  }

  parseJwt(token: string) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  backToMyAccess() {
    if (this.backToken) {
      setAuthTokens({
        accessToken: this.backToken.accessToken,
        refreshToken: this.backToken.refreshToken
      });
      localStorage.removeItem("backToken");
      location.reload();
    }
  }

  get currentToken() {
    return token;
  }

  interval() {
    // Run myfunc every second
    let myfunc = setInterval(() => {
      let now = new Date().getTime();
      let timeleft = this.expired.getTime() - now;

      // Calculating the days, hours, minutes and seconds left
      this.timeLeft.days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      this.timeLeft.hours = Math.floor(
        (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.timeLeft.mins = Math.floor(
        (timeleft % (1000 * 60 * 60)) / (1000 * 60)
      );
      this.timeLeft.seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

      if (timeleft < 0) {
        clearInterval(myfunc);
        this.backToMyAccess();
      }
    }, 1000);
  }

  created() {
    let lsToken = localStorage.getItem("backToken");
    if (lsToken) {
      this.backToken = JSON.parse(lsToken) as {
        accessToken: string;
        refreshToken: string;
      };
      if (this.currentToken) {
        this.expired = new Date(
          this.currentToken.tokenPayload?.exp
            ? this.currentToken.tokenPayload.exp * 1000
            : 0
        );
        setTimeout(() => {
          this.$bvToast.toast(
            `Вы автоматически вернетесь в свой аккаунт через ${this.timeLeft.hours}ч. ${this.timeLeft.mins}м. ${this.timeLeft.seconds}c.`,
            {
              title: `Внимание`,
              variant: "warning",
              autoHideDelay: 5000,
              solid: true
            }
          );
        }, 2000);

        this.interval();
      }
    }
  }
}
